import React from 'react';
import { View } from 'react-native';

import { scale } from '@components/frame';

import { STEPPER_BUTTON_SIZE, STEPPER_DIGIT_WIDTH, STEPPER_RADIUS } from './constants';
import type { StepperCellProps } from '@components/tenantStatus/onboardingWizard/types';

const StepperCell = ({ C, children }: StepperCellProps) => (
  <View
    style={{
      width: scale(STEPPER_DIGIT_WIDTH),
      height: scale(STEPPER_BUTTON_SIZE),
      borderRadius: scale(STEPPER_RADIUS),
      borderWidth: 1,
      borderColor: C('Hairline/Light/No trans [mobile]'),
      alignItems: 'center',
      justifyContent: 'center',
      marginHorizontal: scale(8),
      overflow: 'hidden',
    }}
  >
    {children}
  </View>
);

export default StepperCell;
